import { LoadingDots, Wizard } from '@flos/react-ui';
import { Suspense } from 'react';
import { type CheckoutAccordionConfig } from '../configs/CheckoutAccordionConfig';
import { useRecoilState } from 'recoil';
import { checkoutProgressAtom } from '../../../recoil/atoms/checkoutProgressAtom';

const CheckoutAccordion = ({
    wizardNextStep,
    CheckoutAccordionConfig
}: {
    wizardNextStep: () => void;
    CheckoutAccordionConfig: CheckoutAccordionConfig[];
}): React.JSX.Element => {
    const [currentStep, setCurrentStep] = useRecoilState(checkoutProgressAtom);

    const goNext = (): void => {
        if (currentStep < CheckoutAccordionConfig.length) {
            setCurrentStep((prevStep) => prevStep + 1);
        } else {
            wizardNextStep();
        }
    };

    return (
        <Suspense fallback={<LoadingDots />}>
            <Wizard.Container variant="vertical" currentStep={currentStep}>
                {CheckoutAccordionConfig.map((step, stepIndex) => {
                    const { title, Component } = step;
                    return (
                        <Wizard.Pane
                            key={title}
                            title={title}
                            active={currentStep > stepIndex + 1}
                            onChange={(e) => {
                                if (typeof e === 'number') {
                                    setCurrentStep(e);
                                }
                            }}
                            className="u-spacing-inset-5 u-spacing-inset-7@xs"
                        >
                            <Component goNext={goNext} />
                        </Wizard.Pane>
                    );
                })}
            </Wizard.Container>
        </Suspense>
    );
};

export default CheckoutAccordion;
